import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/landPage/classPurchase/model-1.png'
import _imports_1 from '@/assets/landPage/classPurchase/model-2.png'


const _withScopeId = n => (_pushScopeId("data-v-68db6cea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wxModel-1",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wxModel-2",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.wxModelShow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "wxModel",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
        }, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}